import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Icon,
  Text
} from "@chakra-ui/react";
import { FiActivity, FiPlus } from "react-icons/fi";
import { RiFlaskLine } from "react-icons/ri";
import { Link } from "react-router-dom";

interface ErrorStateProps {
  error: Error;
  refetch: () => void;
}

export function ErrorState({ error, refetch }: ErrorStateProps) {
  return (
    <Container maxW="7xl" py={8}>
      <Box
        maxW="md"
        mx="auto"
        textAlign="center"
        p={8}
        bg="white"
        rounded="2xl"
        shadow="xl"
        border="1px"
        borderColor="red.100"
      >
        <Box
          w={16}
          h={16}
          bg="red.100"
          rounded="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mx="auto"
          mb={6}
        >
          <Icon as={RiFlaskLine} boxSize={8} color="red.500" />
        </Box>
        <Heading size="lg" color="gray.800" mb={2}>
          Something went wrong.
        </Heading>
        <Text color="gray.600" mb={6}>
          {error.message || "We couldn't load your A/B tests. Try again."}
        </Text>
        <HStack gap={3} justify="center">
          <Button
            onClick={() => refetch()}
            colorScheme="blue"
            size="lg"
            _hover={{ transform: "translateY(-2px)" }}
          >
            <Icon as={FiActivity} mr={2} />
            Try Again
          </Button>
          <Link to="/website/ab-test/create">
            <Button variant="outline" colorScheme="blue" size="lg">
              <Icon as={FiPlus} mr={2} />
              Create New A/B Test
            </Button>
          </Link>
        </HStack>
      </Box>
    </Container>
  );
}
